import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import estadoMock from '../../../common/mock/estadoMock';
import global from '../../../common/utility/global';
import { RUC, DNI } from '../../../common/types/tipoDocumentoType';

import choferService from '../../../service/logistica/choferService';
import tipoDocumentoService from '../../../service/administracion/tipoDocumentoService';
import ubigeoService from '../../../service/integracion/ubigeoService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            estados: estadoMock.values,
            filter: {
                nombreChofer: '',
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idTipoDocumento: DNI.ID,
            numeroDocumento: '',
            razonSocial: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            idDepartamento: 0,
            idProvincia: 0,
            idUbigeo: 0,
            direccion: '',
            licencia: '',
            /******************/
            searchLoading: false,
            flagRuc: false,
            tiposDocumento: [],
            departamentos: [],
            provincias: [],
            distritos: []
        }
    };

    handleClearFilters = () => {
        var filter = {
            nombreChofer: '',
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await choferService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Chofer.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await choferService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Chofer.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await choferService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await choferService.eliminar(values);
            else
                response = await choferService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.tiposDocumento = this.state.tiposDocumento;
        formValues.departamentos = this.state.departamentos;
        this.setState({ visible: true, formValues });
    };

    handleBuscarPadronReducido = async (idTipoDocumento, numeroDocumento, form) => {
        this.setState({ formValues: { ...this.state.formValues, searchLoading: true } });
        const response = await padronReducidoService.entidad({ idTipoDocumento, numeroDocumento });

        if (response.status === 200) {
            const provincias = await ubigeoService.provincias(response.data.idDepartamento);
            const distritos = await ubigeoService.distritos(response.data.idProvincia);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false,
                    provincias,
                    distritos
                }
            }, () => {
                form.setFieldsValue({
                    razonSocial: response.data.razonSocial,
                    nombre: response.data.nombre,
                    apellidoMaterno: response.data.apellidoMaterno,
                    apellidoPaterno: response.data.apellidoPaterno,
                    idDepartamento: { key: response.data.idDepartamento > 0 ? response.data.idDepartamento : undefined },
                    idProvincia: { key: response.data.idProvincia > 0 ? response.data.idProvincia : undefined },
                    idUbigeo: { key: response.data.idUbigeo > 0 ? response.data.idUbigeo : undefined },
                    direccion: response.data.direccion,
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false
                }
            });
        }
    };

    handleEdit = async (values) => {
        const response = await choferService.obtenerPorId(values.id);
        if (response !== undefined) {
            response.tiposDocumento = this.state.tiposDocumento;
            response.departamentos = this.state.departamentos;
            response.provincias = await ubigeoService.provincias(response.idDepartamento);
            response.distritos = await ubigeoService.distritos(response.idProvincia);
            response.flagRuc = response.idTipoDocumento === RUC.ID ? true : false;
            this.setState({ visible: true, formValues: response });
        }
    };

    handleChangeForm = async (property, value) => {
        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: provincias ? provincias : [],
                    distritos: []
                }
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    distritos: distritos ? distritos : []
                }
            });
        }

        if (property === "clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: [],
                    distritos: []
                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await choferService.registrar(values);
            else
                response = await choferService.modificar(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                form.setFieldsValue(empty);
                form.resetFields();
                this.setState({ visible: false, formValues: empty });

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };
    async componentDidMount() {
        this._initPagination(this.state.filter, choferService.paginacion);

        const tiposDocumento = await tipoDocumentoService.listarExcluirPlaca();
        const departamentos = await ubigeoService.departamentos();

        this.setState({
            loadingSource: false,
            tiposDocumento: tiposDocumento ? tiposDocumento : [],
            departamentos: departamentos ? departamentos : []
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Chofer"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onChange={this.handleChangeForm}
                    onBuscarPadronReducido={this.handleBuscarPadronReducido}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        )
    }
}